/**
 * Minimal DOM morph. Panels render to HTML strings several times a second;
 * replacing innerHTML would swap a button out from under a press and lose the
 * click. Morphing keeps matching elements in place and only patches text and
 * attributes, so buttons survive a refresh. Give list rows a data-key when
 * their order can change.
 */

function sameNode(a: Node, b: Node): boolean {
  if (a.nodeType !== b.nodeType || a.nodeName !== b.nodeName) return false;
  if (a.nodeType !== Node.ELEMENT_NODE) return true;
  return (a as Element).getAttribute('data-key') === (b as Element).getAttribute('data-key');
}

function syncAttributes(from: Element, to: Element): void {
  for (const attr of Array.from(from.attributes)) {
    if (!to.hasAttribute(attr.name)) from.removeAttribute(attr.name);
  }
  for (const attr of Array.from(to.attributes)) {
    if (from.getAttribute(attr.name) !== attr.value) from.setAttribute(attr.name, attr.value);
  }
}

function morphChildren(from: Node, to: Node): void {
  const current = Array.from(from.childNodes);
  const next = Array.from(to.childNodes);
  for (let i = 0; i < next.length; i += 1) {
    const a = current[i];
    const b = next[i]!;
    if (!a) {
      from.appendChild(b);
    } else if (!sameNode(a, b)) {
      from.replaceChild(b, a);
    } else if (a.nodeType === Node.ELEMENT_NODE) {
      syncAttributes(a as Element, b as Element);
      morphChildren(a, b);
    } else if (a.nodeValue !== b.nodeValue) {
      a.nodeValue = b.nodeValue;
    }
  }
  for (let i = current.length - 1; i >= next.length; i -= 1) from.removeChild(current[i]!);
}

export function morph(host: HTMLElement, html: string): void {
  const template = document.createElement('template');
  template.innerHTML = html;
  morphChildren(host, template.content);
}
